import type { ListObj } from 'src/helper/shared-types';
import type { WorkOrderDataObj } from '../work-order/types';

export type TechnicianSkillMapping = Array<{
  label: string;
  value: string;
  slug: string;
  is_selected?: boolean;
  sub_categories?: TechnicianSkillMapping;
  diagnosis?: TechnicianSkillMapping;
}>;

export type CalendarObj = {
  appointment_type: 'regular' | 'all_day_block_out';
  technician_appointment_id: string;
  appointment_id: string;
  start_time: string;
  end_time: string;
  appointment_date: string;
  /** Block-out mutations answer with a wall `date` and the window's own zone; appointments do not. */
  date?: string;
  timezone?: string;
  is_block_out_all_day: boolean;
  technician: {
    technician_id: string;
    name: string;
  };
  note?: string;
  work_order?: {
    work_order_id: WorkOrderDataObj['work_order_id'];
    work_order_number: WorkOrderDataObj['work_order_number'];
    status: {
      label: string;
      value: string;
    };
    timezone: WorkOrderDataObj['timezone'];
    property: {
      address: {
        street_address?: string;
        apt_suite_unit?: string;
        city?: string;
        state_code?: string;
        zip_code?: string;
      };
      name: string;
      location?: {
        latitude: string;
        longitude: string;
      };
      residents?: Array<{
        resident_id: string;
        first_name: string;
        last_name: string;
        phone_number: string;
        email: string;
      }>;
      state?: {
        value: string;
        label: string;
      };
      property_id?: string;
    };
    priority: WorkOrderDataObj['priority'];
    category: WorkOrderDataObj['category'];
  };
};

export type CalendarDay = {
  is_block_out_all_day: boolean;
  regular_appointment_exist: boolean;
  block_out_appointment_exist: boolean;
  appointment_date: string;
};
export interface UserDataType {
  account_info: {
    user_id: string;
    first_name: string;
    last_name: string;
    middle_name: string;
    is_active: boolean;
    email: string;
    phone_number: string;
    new_password: string;
    is_technician: boolean;
    confirm_new_password: string;
    address: {
      country: {
        value: string;
        label: string;
      };
      street_address: string;
      state_code: string;
      apt_suite_unit: string;
      city: string;
      state: {
        value: string;
        label: string;
      };
      zip_code: string;
    };
    current_roles: [
      {
        value: string;
        label: string;
      },
    ];
    role_editable: boolean;
    user_type: string;
    password_last_updated: {
      user: {
        name: string;
      };
      date: string;
    };
  };
  group: string;
  last_activity: string;
  working_hours: {
    [key: string]: {
      from: string;
      to: string;
      isEnabled: boolean;
      duration?: string;
    };
  };
  technician_id?: string;
  selected_skills: {
    selected_diagnosis_ids: string[];
    selected_problem_category_ids: string[];
    selected_sub_category_ids: string[];
  };
  profile_pic: string;
  notifications: {
    email: boolean;
    sms: boolean;
    push: boolean;
  };
  roles: {
    value: string;
    label: string;
  }[];
  roleOptions: {
    value: string;
    label: string;
  }[];
  markets?: Array<{
    id: string;
    name: string;
  }>;
  timezone: string;
  calendar: {
    [key: string]: Array<CalendarDay>;
  };
  agenda: {
    selectedDate: string;
    list: Array<ListObj>;
  };
}

export type InitialStateType = {
  source: {
    [key: string]: UserDataType;
  };
  calendarSource: {
    [key: string]: CalendarObj;
  };
};

export const userListInitialState: InitialStateType = {
  source: {},
  calendarSource: {},
};
